import { getApi } from './Api';
import { AppState } from './App'
import './DeleteConfirmation.css';
import React from 'react';
import { DeleteAccount400Response, DeleteAccount403Response, DeleteAccountRequest } from './api';
import axios, { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';

interface ComponentProps {
	changeState: (newState: AppState) => void
	phoneNumber: string
}

type State = {
	formatedFurtureDate: string
	buttonDisabled: boolean
}
export default class DeleteConfirmation extends React.Component<ComponentProps, State> {

	state: State

	constructor(props: ComponentProps) {
		console.log('DeleteConfirmation')
		super(props)

		const now = new Date();
		const futureDate = new Date(now.setDate(now.getDate() + 7));
		const formattedFutureDate = new Intl.DateTimeFormat('en-US', {
			year: 'numeric',
			month: 'long',
			day: '2-digit'
		}).format(futureDate);

		this.state = {
			formatedFurtureDate: formattedFutureDate,
			buttonDisabled: true
		}
	}

	componentDidMount() {
	}

	// Handle checkbox change
  handleCheckboxChange = (event: any) => {
    // Update the buttonDisabled state based on whether the checkbox is checked
    this.setState({ buttonDisabled: !event.target.checked });
  }

	deleteAccount = (e: React.FormEvent) => {
		const api = getApi()
		e.preventDefault();
		console.log('sending deleteAccount request for phonenumber:', this.props.phoneNumber)
		const req: DeleteAccountRequest = {
			phoneNumber: this.props.phoneNumber
		}
		api.deleteAccount(req).then(
			(resp: AxiosResponse) => {
				console.log('deleteAccount success, code:', resp.status)
				if (resp.status === 200) {
					this.props.changeState(AppState.STATE_ACCOUNT_DELETED)
				}
			}).catch((error: any) => {
				if (axios.isAxiosError(error)) {
					// Now you can access error.response
					if (error.response) {
						switch (error.response.status) {
							case 400:
								const errorData400 = error.response.data as DeleteAccount400Response;
								console.log('400 Error: ', errorData400);
								break;
							case 403:
								const errorData403 = error.response.data as DeleteAccount403Response;
								console.log('403 Error: ', errorData403);
								toast("Please verify your identity first", {
									duration: 5000,
									position: "top-center",
									style: { backgroundColor: "#2E3237", color: "#FFFFFF", fontSize: "30px" },
								});
								this.props.changeState(AppState.STATE_INITIAL)
								break;
							default:
								// Handle other errors
								console.log('Other Error: ', error.response.data);
						}
					} else {
						// The request was made but no response was received
						console.log('Error: No response received', error.message);
					}
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log('Error: ', error.message);
				}
			})
	}

	render() {
		return (
			<div className="delete-confirmation-container">
				<div className="delete-confirmation-card">
					<form>
						<div className="logos">
							{/* Add your logos here */}
						</div>
						<h1>Please read this carefully. It is Important</h1>
						<div className="message">
							<p>You are about to permanently delete your account which uses both Odience and Verse.</p>
							<p>You will no longer be able to send or receive messages, and all your data (messages, images, files, contacts), <strong>for both Odience and Verse</strong>, will be lost for this account.</p>
							<p>if you continue, your account will be permanently deleted in 7 days, on <strong>{`${this.state.formatedFurtureDate}`}</strong>. You can cancel the deletion process at any time between now and then by logging into your account through either Odience or Verse.</p>
						</div>
						<label>
						<input
							type="checkbox"
							onChange={this.handleCheckboxChange}
							/>Yes, I want to permanently delete my account and all its data.</label>
						<button type="submit"
							disabled={this.state.buttonDisabled}
							onClick={this.deleteAccount}>Log in to account</button>
					</form>
				</div>
			</div>
		);
	}
};
